module.exports = __webpack_public_path__ + "img/himachal.b276021a.png";